import { Constants } from '../constants';
import { AttackRollInput } from '../types';

export function executeAttackRoll(input: AttackRollInput): number {
    const precisionBonus = getTotalPrecisionBonus(input);
    const closingReRolls = getClosingReRolls(input);

    let minRoll = Math.max(input.toHitValue - precisionBonus, 2); // a 1 always misses

    let numHits = Array.from({ length: input.stats.attackDice }, () => rollDie()).filter(
        (roll) => roll >= minRoll || roll === 10,
    ).length;

    if (!input.disableReRolls) {
        const numMisses = input.stats.attackDice - numHits;
        const numReRolls = Math.min(numMisses, input.stats.attackReRolls + closingReRolls);
        numHits += Array.from({ length: numReRolls }, () => rollDie()).filter((roll) => roll >= minRoll).length;
    }

    return numHits;
}

/**
 * PRIVATE
 */

function rollDie(): number {
    return Math.ceil(Math.random() * Constants.ATTACK_DICE_SIDES);
}

function getTotalPrecisionBonus(input: AttackRollInput): number {
    // Opening and Closing tokens both provide precision
    return (
        input.kratosPool.opening +
        input.kratosPool.closing +
        input.stats.autoTokens.opening +
        (input.stats.autoTokens.closing ?? 0) +
        input.stats.precisionBonus
    );
}

function getClosingReRolls(input: AttackRollInput): number {
    return input.kratosPool.closing + (input.stats.autoTokens.closing ?? 0);
}
